import axios from 'axios';

export default {
    async list({ customer, page, perPage, sortBy, direction, status, search }) {
        let customer_id = customer ? customer.id : null;
        let response = await axios.get('/api/wishlists/items', { params: { customer_id, page, perPage, sortBy, direction, status, search } });
        return response.data;
    },
    async get(id) {
        let response = await axios.get(`/api/wishlists/items/${id}`);
        return response.data;
    },
    async find(code) {
        let response = await axios.get(`/api/wishlists/items/code/${code}`);
        return response.data;
    },
    async create(wishlistItem = {}) {
        let response = await axios.post('/api/wishlists/items', wishlistItem);
        return response.data;
    },
    async createMultiple(wishlistItem = {}) {
        let response = await axios.post('/api/wishlists/items/multiple', wishlistItem);
        return response.data;
    },
    async update(wishlistItem) {
        let response = await axios.patch(`/api/wishlists/items/${wishlistItem.id}`, wishlistItem);
        return response.data;
    },
    async updateStatus(wishlistItem) {
        let response = await axios.patch(`/api/wishlists/items/${wishlistItem.id}/status`, wishlistItem);
        return response.data;
    },
    async updatePhoneCallStatus(wishlistItem) {
        let response = await axios.patch(`/api/wishlists/items/${wishlistItem.id}/phoneCallStatus`, wishlistItem);
        return response.data;
    },
    async updateTextMessageStatus(wishlistItem) {
        let response = await axios.patch(`/api/wishlists/items/${wishlistItem.id}/textMessageStatus`, wishlistItem);
        return response.data;
    },
    async delete(wishlistItem) {
        let response = await axios.delete(`/api/wishlists/items/${wishlistItem.id}`);
        return response.data;
    },
}
